export const setHttp = link => {
  if (link && link.search(/^http[s]?\:\/\//) === -1) {
    return `http://${link}`;
  }
  return link;
}